import React, { useCallback, useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { getBlogData } from "services/_blog";
import moment from "moment";
import Pagination from "components/Pagination";
import rightArrow from "../../assets/images/right-arrow.svg";
import calender from "../../assets/images/calender.svg";
import Spondyloarthritis from "./components/Spondyloarthritis";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const BlogPage = ({ isPagination }) => {
  const [blogData, setBlogData] = useState([]);
  const [records, setRecords] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage] = useState(4);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const navigate = useNavigate();

  const initialData = useCallback(async () => {
    const data = await getBlogData(`page=${page}&per_page=${perPage}`);
    if (data?.data) {
      setRecords(data.data.records || []);
      setBlogData(data.data.records);
      setTotalRecords(data.data.total_records || 0);

      if (data.data.total_records && perPage) {
        setTotalPages(Math.ceil(data.data.total_records / perPage));
      }
    }
  }, [page, perPage]);

  useEffect(() => {
    initialData();
  }, [initialData]);

  const prevButton = async () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const nextButton = async () => {
    if (totalPages > page) {
      setPage(page + 1);
    }
  };
  const manBlogeData = isPagination ? blogData : blogData.slice(0, 3);

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <section className="py-[20px] bg-[rgba(223,228,234,0.38)] ">
        <div className="container">
          <div className="flex justify-center">
            <h1 className="heading">Latest Articles</h1>
          </div>

          <div className="flex md:gap-[30px] latest_articles_grid mt-[40px] gap-[20px] flex-wrap justify-center ">
            {blogData.length > 0 ? (
              manBlogeData.slice(0, 3).map((blog) => {
                const formattedDate = moment(blog.created_at).format(
                  "MMMM DD, YYYY"
                );
                const imageUrl = `${BACKEND_URL}${blog.image_url}`;
                return (
                  <>
                    <div className="articles_box box max-w-[410px] rounded-[15px] w-full">
                      <div className="condion_box h-full  flex flex-col min-h-[343px] overflow-hidden bg-white max-w-[410px] relative w-full rounded-[15px] ">
                        <div className="bloge_img_box relative p-[15px] rounded-[15px]  ">
                          <div className="bg-[#1F2B6C] p-[10px] w-max h-[45px] absolute bottom-[15px] z-[88] ">
                            <p className="text-[15px] flex gap-[10px] text-white font-[500]  ">
                              <img src={calender} alt="" />
                              {formattedDate}
                            </p>
                          </div>
                          <img
                            src={imageUrl}
                            alt=""
                            className="w-full h-[255px] object-cover rounded-[15px] "
                          />
                        </div>

                        <div className="condition_content  flex flex-col justify-between h-full   relative">
                          <div
                            className={`${
                              !isPagination ? "pb-[15px]" : ""
                            } pt-[15px] px-[15px]`}
                          >
                            <h2 className="text-[18px] mb-[7px]  font-[700] text-[#000D44] ">
                              {blog.title}
                            </h2>
                            <p className="text-[15px]  line-clamp-2 font-[500] text-[#000D44]">
                              {blog.short_description}
                            </p>
                          </div>
                         
                            <div className="flex justify-end">
                              <button
                              onClick={() =>
                              navigate(`/blogs/view-blogs/${blog.id}`)
                            }
                                className="font-[400] !rounded-tr-none !rounded-bl-none rounded-[5px] p-[7px] px-[12px] bg-[#1F2B6C] text-white "
                              >
                                <div className="button_box w-[39px] flex justify-center rounded-[3px] items-center h-[30px] bg-white ">
                                  <img
                                    src={rightArrow}
                                    alt=""
                                    className="invert-1 w-[22px]"
                                  />
                                </div>
                              </button>
                            </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })
            ) : (
              <>
                <h1 className="text-center">No Data found</h1>
              </>
            )}
          </div>
          {!isPagination && (
            <div className="flex justify-end  mt-[50px]">
              <NavLink
                to="/blogs"
                className="font-[400] flex items-center gap-[10px] rounded-[5px] p-[7px] px-[12px] bg-[#1F2B6C] text-white "
              >
                View More
                <div className="button_box w-[39px] flex justify-center rounded-[3px] items-center h-[30px] bg-white ">
                  <img src={rightArrow} alt="" className="invert-1 w-[22px]" />
                </div>
              </NavLink>
            </div>
          )}

          {isPagination && (
            <div className="md:py-[20px] py-[10px]">
              <Pagination
                page={page}
                perPage={perPage}
                totalRecords={totalRecords}
                totalPages={totalPages}
                records={records}
                prevButton={prevButton}
                nextButton={nextButton}
              />
            </div>
          )}
        </div>
      </section>
      {isPagination && <Spondyloarthritis />}
    </div>
  );
};

export default BlogPage;
